import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/logements", label: "Nos logements" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export function LogoMark({ size = 44, className = "" }) {
  return (
    <img
      src="/logo.jpg"
      alt="Golden Aura Pro"
      width={size}
      height={size}
      className={`rounded-full object-cover ring-1 ring-[#D4AF37]/50 ${className}`}
      data-testid="brand-logo"
    />
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0F1E]/85 border-b border-[#D4AF37]/15" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-home-link">
          <LogoMark size={46} className="transition-transform duration-500 group-hover:rotate-[15deg]" />
          <span className="font-display text-lg sm:text-xl tracking-[0.18em] text-[#F6F1E6]">
            GOLDEN <span className="gold-text">AURA</span> PRO
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
              className={({ isActive }) =>
                `text-xs tracking-[0.22em] uppercase transition-colors duration-300 ${
                  isActive ? "text-[#E5C158]" : "text-[#B9BFD0] hover:text-[#F6F1E6]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => navigate("/logements")}
            data-testid="header-booking-cta"
            className="gold-button rounded-full px-6 py-2.5 text-xs font-medium tracking-[0.18em] uppercase"
          >
            Réserver
          </button>
        </nav>

        <button
          className="md:hidden text-[#E5C158] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="md:hidden border-t border-[#D4AF37]/15 bg-[#0A0F1E]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5" data-testid="mobile-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-[0.2em] uppercase ${isActive ? "text-[#E5C158]" : "text-[#B9BFD0]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => { setOpen(false); navigate("/logements"); }}
            data-testid="mobile-booking-cta"
            className="gold-button rounded-full px-6 py-3 text-xs font-medium tracking-[0.18em] uppercase mt-2"
          >
            Réserver un séjour
          </button>
        </nav>
      )}
    </header>
  );
}
